import {createContext, useContext, useEffect, useState} from "react";
import {testStatus} from "../../../entities/testStatus";
import {getCookie, setCookie} from "../../../services/connectors/cookies";
import {logout} from "../../../services/auth.services";


export const useTestStatusContext = createContext({
  status: testStatus.DEMOGRAPHIC as testStatus,
  setStatus: (status: testStatus) => {
  },
  testProgress: 5,
  setTestProgress: (progress: number) => {
  }
});

export function TestStatusProvider(props: { children: React.ReactNode }) {
  const [status, setStatus] = useState<testStatus>(testStatus.DEMOGRAPHIC)
  const [testProgress, setTestProgress] = useState<number>(5);

  useEffect(() => {
    setCookie('test_status', status, 1);
  }, [status]);
  useEffect(() => {
    setCookie('test_progress', testProgress.toString(), 1);
  }, [testProgress]);


  return (
    <useTestStatusContext.Provider value={{status, setStatus, testProgress, setTestProgress}}>
      {props.children}
    </useTestStatusContext.Provider>
  );
}


export const useTestStatus = () => useContext(useTestStatusContext);